import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Alert from '@mui/material/Alert';

const AlertBox = (props) => {
  const { isOpen, onClose, handleSubmit, breakPointsData } = props;
  const { greaterThan768, greaterthan375, responsiveData } = breakPointsData;
  // const [open, setOpen] = React.useState(false);

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  // const handleClose = () => {
  //   setOpen(false);
  // };

  return (
    <React.Fragment>
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Open alert dialog
      </Button> */}
      <Dialog
        open={isOpen}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle sx={{ fontSize: responsiveData.fontSize }} id="alert-dialog-title">
          {"Password Reset"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ fontSize: responsiveData.fontSize }} id="alert-dialog-description">
            <Alert severity={props.status}> {props.text}</Alert>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>Disagree</Button> */}
          <Button sx={{ fontSize: responsiveData.fontSize }} onClick={handleSubmit} autoFocus>
            Done
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default AlertBox
